module.exports = __webpack_public_path__ + "ao.no2.fe699c6f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/ao.no2.jpg
// module id = coVn
// module chunks = 0